export default "__VITE_ASSET__3774f76a__"